import {
  FETCH_API_KEYS_SUCCESS,
  FETCH_API_KEYS_FAIL,
  CREATE_API_KEY_SUCCESS,
  CREATE_API_KEY_FAIL,
  DELETE_API_KEY_SUCCESS,
  DELETE_API_KEY_FAIL,
} from "../Actions/APIKeys";

const initialState = {
  apiKeys: [],
  loading: false,
  error: null,
  newApiKey: null, // Stores the newly created key (with full key) temporarily
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_API_KEYS_SUCCESS:
      return {
        ...state,
        apiKeys: action.payload,
        loading: false,
        error: null,
      };

    case FETCH_API_KEYS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_API_KEY_SUCCESS:
      return {
        ...state,
        apiKeys: [...state.apiKeys, action.payload],
        newApiKey: action.payload, // Store full key temporarily
        loading: false,
        error: null,
      };

    case CREATE_API_KEY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_API_KEY_SUCCESS:
      return {
        ...state,
        apiKeys: state.apiKeys.filter((key) => key.id !== action.payload),
        loading: false,
        error: null,
      };

    case DELETE_API_KEY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
